import { useMemo } from 'react';

import { SKILLED_NURSING_FACILITY } from 'constants/locationTypes';
import { getBusinessDevelopmentAnalyticsFilters, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

import { useBusinessDevelopmentContext } from '../BusinessDevelopmentContainer';

export default function useBusinessDevelopmentFilters() {
  const { predecessorGroupTypes } = useBusinessDevelopmentContext();
  const snfTypeId = useMemo(
    () => predecessorGroupTypes.find((gt) => gt.apiName === SKILLED_NURSING_FACILITY)?.id,
    [predecessorGroupTypes]
  );

  const baseFilters = useBusinessDevelopmentStore((state) => getBusinessDevelopmentAnalyticsFilters(state));

  return useMemo(() => {
    if (!baseFilters || !snfTypeId) return null;
    return { ...baseFilters, predecessorGroupType: [{ id: snfTypeId }] };
  }, [baseFilters, snfTypeId]);
}
